import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cart-widget__item__remove" }
const _hoisted_2 = {
  class: "col-12 col-xl",
  ref: "colLeft"
}
const _hoisted_3 = { class: "cart-widget__items__item__title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "fs-regular"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseGridCol = _resolveComponent("BaseGridCol")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.product.name
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      (!_ctx.isOrderCancel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createTextVNode(" Das Produkt "),
            _createElementVNode("i", {
              innerHTML: _ctx.product.name
            }, null, 8, _hoisted_6),
            _createTextVNode(" aus deinem Warenkorb entfernen? ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createTextVNode(" Das Produkt "),
            _createElementVNode("i", {
              innerHTML: _ctx.product.name
            }, null, 8, _hoisted_8),
            _createTextVNode(" aus deinem Warenkorb entfernen und die aktuelle Bestellung abbrechen? ")
          ])),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      _createVNode(_component_BaseGridRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_BaseGridCol, { s: { xs: 12, lg: 6} }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                "link-type": "button",
                width: "full",
                color: "dark-outline",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('clear')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Nein ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_BaseGridCol, { s: { xs: 12, lg: 6} }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                "link-type": "button",
                width: "full",
                color: "red-orange",
                onClick: _ctx.onApprove
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ja ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512)
  ]))
}